import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getInstitutions, deleteInstitution } from "../../actions/institutionActions";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import 'react-datepicker/dist/react-datepicker.css';
import 'react-table/react-table.css';
import 'react-report-builder/lib/main.css';


class InstitutionList extends Component {
  constructor() {
    super();
    this.state = {
      errors: {}
    };
    this.addInstitution = this.addInstitution.bind(this);
    this.editInstitution = this.editInstitution.bind(this);
    this.deleteInstitution = this.deleteInstitution.bind(this);
    this.viewInstitution=this.viewInstitution.bind(this);
  }

  componentDidMount() {
    this.props.getInstitutions();
  }

  addInstitution() {
    this.props.history.push("/add-institution");
  }
  editInstitution(institutionId) {
    this.props.history.push(`/edit-institution/${institutionId}`);
  }

  deleteInstitution(institutionId) {
    this.props.deleteInstitution(institutionId);
  }

  viewInstitution(institutionId) {
    this.props.history.push(`/view-institution/${institutionId}`);
  }

  render() {
    
    
    const { institutions } = this.props.institution;
    const header = (
      <div style={{ textAlign: "left" }}>
        <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
        <InputText
          type="search"
          onInput={(e) => this.setState({ globalFilter: e.target.value })}
          placeholder="Global Search"
          size="50"
        />
        <button
          className="btn btn-success  float-right"
          onClick={() => this.addInstitution()}
        >
          Add Institution
        </button>
      </div>
    );

    const paginatorLeft = <Button icon="pi pi-refresh"/>;
    const actionTemplate = (rowData, column) => {
      return (
        <div>
          <Button
            type="button"
            icon="pi pi-search"
            className="p-button-success"
            onClick={() => this.viewInstitution(rowData.id)}
            style={{ marginRight: ".2em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-warning"
            onClick={() => this.editInstitution(rowData.id)}
            style={{ marginRight: ".3em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-times"
            className="p-button-danger"
            onClick={() => this.deleteInstitution(rowData.id)}
          ></Button>
        </div>
      );
    };

    

    return (
      <div>
        <div className="container-fluid mt-4">
          
        <div className="card m-auto  shadow-lg rounded p-3">
              <h1 className="m-auto text-center display-4">Institution List</h1>
              <p className="lead text-center">List of all institutions</p>
              <hr/>
              
              
                <DataTable value={institutions} paginator={true} paginatorLeft={paginatorLeft} header={header}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
                    rows={50} rowsPerPageOptions={[50,100,500]} 
                    globalFilter={this.state.globalFilter} emptyMessage="No records found" >

                
                  <Column
                    field="institutionName"
                    header="Institution Name"
                   />
                  <Column
                    field="phone"
                    header="Phone"
                  />
                  <Column
                    field="email"
                    header="Email"
                   />
                   <Column field="branch.branchName" header="Branch" />
                  <Column field="sector.sectorName" header="Sector" />
                  <Column field="tuPercentage" header="TU Percentage" />
                  <Column field="currency" header="Currency" />
                  <Column
                    body={actionTemplate.bind(this)}
                    header="Actions"
                    style={{ textAlign: "center" }}
                  />
                </DataTable>
            
              
            </div>
          </div>
        </div>
       
    
    );
  }
}
InstitutionList.propTypes = {
  getInstitutions: PropTypes.func.isRequired,
  deleteInstitution: PropTypes.func.isRequired,
  
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  institution: state.institution,
  errors: state.errors
});

export default connect(mapStateToProps, { getInstitutions, deleteInstitution })(InstitutionList);
